import BaseAbility from 'umg-ember-backend/abilities/base';

export default class StoryAbility extends BaseAbility {}
